import { authoringApi } from '@ane/exp-data/lib/redux/rtkquery/authoring';
import { configureStore } from '@reduxjs/toolkit';

import { epicMiddleware, middlewareCollection, rootEpic } from '../middleware';
import rootReducer from '../reducers/RootReducer';
import {
  vnextExpAnalysisApi,
  expFeatureReadV2Api,
  xCardApi,
  xCardScorecardApi,
  notificationHubApi,
  notificationHubV1Api,
  ctmApi,
  mdsApi,
} from '@ane/exp-data/lib/redux/rtkquery';

/**
 * Initialize the store
 */
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(middlewareCollection as any)
      .concat(authoringApi.middleware)
      .concat(vnextExpAnalysisApi.middleware)
      .concat(expFeatureReadV2Api.middleware)
      .concat(xCardApi.middleware)
      .concat(xCardScorecardApi.middleware)
      .concat(notificationHubApi.middleware)
      .concat(notificationHubV1Api.middleware)
      .concat(ctmApi.middleware)
      .concat(mdsApi.middleware),
});

/**
 * Then run the middleware
 */
epicMiddleware.run(rootEpic as any);

export default store;
